import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SpinnerService } from "../acesso/spinner/spinner.service";

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService){ }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //opção para não armazenar cache
    req = req.clone({
      setHeaders: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });

    this.spinnerService.iniciarSpinner();

    // req = req.clone({
    //   setHeaders: {
    //     "Cache-Control": "no-cache",
    //     Pragma: "no-cache",
    //   }
    // });

    return this.handler(next, req);
  }


  handler(next, req){

    return next.handle(req)
    .pipe(
      tap(
        (event) => {
          if(event instanceof HttpResponse){
            this.spinnerService.pararSpinner();
          }
        },
        (error: Interceptor) => {
          this.spinnerService.resetarSpinner();
          throw error;
        }
      ),
    );
  }
}
